import React from 'react';
import block from 'bem-cn-lite';

import './FieldBottomLabel.scss';

const b = block('FieldBottomLabel');

export interface FieldBottomLabelProps {
    className?: string;
}

const FieldBottomLabel: React.FunctionComponent<FieldBottomLabelProps> = ({
    className,
    children,
}) => <div className={b(null, className)}>{children}</div>;

export default FieldBottomLabel;
